// removed by extract-text-webpack-plugin
module.exports = {"root":"Header__root___3wcYK","root--basic":"Header__root--basic___gG9Hx","title":"Header__title___3-8RD","close":"Header__close___28Mnw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseModal/Header/Header.scss
// module id = 1020
// module chunks = 0